import React, { useState, useEffect } from "react";
import { Card, Form, Button, Alert, Row, Col } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ResponsiblesService from "../services/api/responsibles";

const ResponsibleFormPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = !!id;
  
  console.log('🚀 ResponsibleFormPage renderizado:', { id, isEditing });

  const [loading, setLoading] = useState(false);
  const [cepLoading, setCepLoading] = useState(false);
  const [formData, setFormData] = useState({
    // Dados do responsável (PJ)
    responsible_cpf: '',
    state_registration: '',
    company_name: '',          // ✅ Razão social
    trading_name: '',          // ✅ Nome fantasia
    responsible_phone: '',
    founding_date: '',         // ✅ Data de fundação (PJ)
    site_url: '',              // ✅ NOVO - Site da empresa (PJ - OBRIGATÓRIO)
    annual_revenue: '',        // ✅ NOVO - Faturamento anual (PJ)
    
    // Dados do sócio administrador (PF)
    admin_cpf: '',
    admin_name: '',
    admin_mother_name: '',
    admin_birth_date: '',
    monthly_income: '',        // ✅ NOVO - Renda mensal (PF)
    professional_occupation: '', // ✅ NOVO - Ocupação profissional (PF)
    
    // Dados do endereço
    address_cep: '',
    address_street: '',
    address_number: '',
    address_complement: '',
    address_neighborhood: '',
    address_city: '',
    address_state: '',
    address_reference: '',     // ✅ NOVO - Ponto de referência (OBRIGATÓRIO)
    
    is_main_responsible: false
  });
  const [errors, setErrors] = useState({});
  
  // Estados para gerenciar documentos
  const [documents, setDocuments] = useState([]);
  const [pendingDocuments, setPendingDocuments] = useState([]); // Documentos aguardando criação do responsável
  const [uploadingDocument, setUploadingDocument] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState('CNH');
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [deletingDocument, setDeletingDocument] = useState(false);

  // Carregar dados para edição e documentos
  useEffect(() => {
    console.log('🔄 useEffect executado:', { isEditing, id });
    if (isEditing && id) {
      console.log('✅ Condições atendidas, carregando dados...');
      loadResponsibleData();
      loadDocuments();
    } else {
      console.log('❌ Condições não atendidas:', { isEditing, id });
    }
  }, [id, isEditing]);

  // Função para carregar dados do responsável
  const loadResponsibleData = async () => {
    try {
      setLoading(true);
      console.log('🔍 Carregando dados do responsável:', id);
      const response = await ResponsiblesService.getResponsible(id);
      console.log('📊 Dados do responsável carregados:', response);
      
      if (response && response.success && response.data) {
        const responsible = response.data;
        console.log('✅ Responsável encontrado, preenchendo formulário:', responsible);
        console.log('🔍 Dados específicos:', {
          company_name: responsible.company_name,
          admin_name: responsible.admin_name,
          address_cep: responsible.address_cep
        });
        
        // Função para converter data ISO para yyyy-MM-dd
        const formatDateForInput = (isoDate) => {
          if (!isoDate) return '';
          try {
            const date = new Date(isoDate);
            return date.toISOString().split('T')[0]; // Retorna apenas yyyy-MM-dd
          } catch (error) {
            console.error('Erro ao formatar data:', error);
            return '';
          }
        };
        
        setFormData({
          // Dados do responsável (PJ)
          responsible_cpf: responsible.responsible_cpf || '',
          state_registration: responsible.state_registration || '',
          company_name: responsible.company_name || '',
          trading_name: responsible.trading_name || '',
          responsible_phone: responsible.responsible_phone || '',
          founding_date: formatDateForInput(responsible.founding_date) || '',
          company_name: responsible.company_name || responsible.company_name || '',
          trading_name: responsible.trading_name || responsible.trading_name || '',
          site_url: responsible.site_url || '',
          annual_revenue: responsible.annual_revenue ? (responsible.annual_revenue / 100).toFixed(2) : '',
          
          // Dados do sócio administrador (PF)
          admin_cpf: responsible.admin_cpf || '',
          admin_name: responsible.admin_name || '',
          admin_mother_name: responsible.admin_mother_name || '',
          admin_birth_date: formatDateForInput(responsible.admin_birth_date),
          monthly_income: responsible.monthly_income ? (responsible.monthly_income / 100).toFixed(2) : '',
          professional_occupation: responsible.professional_occupation || '',
          
          // Dados do endereço
          address_cep: responsible.address_cep || '',
          address_street: responsible.address_street || '',
          address_number: responsible.address_number || '',
          address_complement: responsible.address_complement || '',
          address_neighborhood: responsible.address_neighborhood || '',
          address_city: responsible.address_city || '',
          address_state: responsible.address_state || '',
          address_reference: responsible.address_reference || '',
          
          is_main_responsible: responsible.is_main_responsible || false,
          
          // Status e motivo de rejeição (para exibir no alert)
          status: responsible.status || '',
          rejection_reason: responsible.rejection_reason || ''
        });
        
        console.log('✅ Formulário preenchido com sucesso!');
      } else {
        console.error('❌ Resposta inválida:', response);
        toast.error('Erro ao carregar dados do responsável');
        // Não redirecionar imediatamente, deixar o usuário tentar novamente
      }
    } catch (error) {
      console.error('❌ Erro ao carregar responsável:', error);
      toast.error('Erro ao carregar dados do responsável');
      // Não redirecionar imediatamente, deixar o usuário tentar novamente
    } finally {
      setLoading(false);
    }
  };

  // Função para buscar CEP
  const handleCepSearch = async (cep) => {
    if (!cep || cep.length < 8) return;
    
    setCepLoading(true);
    
    try {
      console.log('🔍 Buscando CEP:', cep);
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      
      if (data.erro) {
        toast.warning('CEP não encontrado');
        return;
      }
      
      console.log('✅ CEP encontrado:', data);
      
      // Preencher automaticamente os campos de endereço
      setFormData(prev => ({
        ...prev,
        address_cep: cep,
        address_street: data.logradouro || '',
        address_neighborhood: data.bairro || '',
        address_city: data.localidade || '',
        address_state: data.uf || ''
      }));
      
      toast.success('Endereço preenchido automaticamente!');
      
    } catch (error) {
      console.error('❌ Erro ao buscar CEP:', error);
      toast.error('Erro ao buscar CEP');
    } finally {
      setCepLoading(false);
    }
  };

  // Manipular mudanças no formulário
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = type === 'checkbox' ? checked : value;

    // Formatação automática para CPF/CNPJ
    if (name === 'responsible_cpf') {
      // CNPJ
      const numbers = value.replace(/[^\d]/g, '');
      if (numbers.length <= 14) {
        finalValue = numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
    } else if (name === 'admin_cpf') {
      // CPF
      finalValue = ResponsiblesService.formatCPF(value);
    }

    // Formatação automática para telefone
    if (name === 'responsible_phone') {
      finalValue = ResponsiblesService.formatPhone(value);
    }

    // Formatação automática para CEP
    if (name === 'address_cep') {
      finalValue = value.replace(/[^\d]/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');
      
      // Buscar CEP automaticamente quando tiver 8 dígitos
      const cepNumbers = value.replace(/[^\d]/g, '');
      if (cepNumbers.length === 8) {
        handleCepSearch(cepNumbers);
      }
    }

    // ✅ NOVO - Formatação automática para valores monetários
    if (name === 'monthly_income' || name === 'annual_revenue') {
      // Permitir apenas números e vírgula/ponto
      const numbers = value.replace(/[^\d.,]/g, '');
      finalValue = numbers;
    }

    setFormData(prev => ({
      ...prev,
      [name]: finalValue
    }));

    // Limpar erro do campo quando o usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Validar formulário
  const validateForm = () => {
    const newErrors = {};

    // ===== DADOS DO RESPONSÁVEL (PJ) =====
    
    // Validar CNPJ do responsável
    if (!formData.responsible_cpf.trim()) {
      newErrors.responsible_cpf = 'CNPJ do responsável é obrigatório';
    } else if (!ResponsiblesService.validateCPF(formData.responsible_cpf)) {
      newErrors.responsible_cpf = 'CNPJ do responsável inválido';
    }

    // ✅ NOVO - Validar data de fundação (PJ)
    if (!formData.founding_date) {
      newErrors.founding_date = 'Data de fundação é obrigatória';
    }

    // ✅ NOVO - Validar site da empresa (PJ - OBRIGATÓRIO)
    if (!formData.site_url.trim()) {
      newErrors.site_url = 'Site da empresa é obrigatório';
    } else {
      // Validar formato de URL de forma mais flexível
      try {
        const url = new URL(formData.site_url);
        // Verificar se começa com http ou https
        if (!url.protocol.startsWith('http')) {
          newErrors.site_url = 'URL deve começar com http:// ou https://';
        }
      } catch (e) {
        newErrors.site_url = 'URL inválida. Exemplo: https://www.empresa.com.br';
      }
    }

    // ✅ NOVO - Validar faturamento anual (PJ - opcional, mas se preenchido deve ser válido)
    if (formData.annual_revenue && isNaN(parseFloat(formData.annual_revenue))) {
      newErrors.annual_revenue = 'Faturamento deve ser um valor numérico';
    }

    // ===== DADOS DO SÓCIO ADMINISTRADOR (PF) =====
    
    // Validar CPF do administrador
    if (!formData.admin_cpf.trim()) {
      newErrors.admin_cpf = 'CPF do administrador é obrigatório';
    } else if (!ResponsiblesService.validateCPF(formData.admin_cpf)) {
      newErrors.admin_cpf = 'CPF do administrador inválido';
    }

    // Validar nome do administrador
    if (!formData.admin_name.trim()) {
      newErrors.admin_name = 'Nome do administrador é obrigatório';
    }

    // ✅ NOVO - Validar nome da mãe (PF)
    if (!formData.admin_mother_name.trim()) {
      newErrors.admin_mother_name = 'Nome da mãe é obrigatório';
    }

    // Validar data de nascimento (PF)
    if (!formData.admin_birth_date) {
      newErrors.admin_birth_date = 'Data de nascimento é obrigatória';
    } else {
      const birthDate = new Date(formData.admin_birth_date);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();
      
      if (age < 18) {
        newErrors.admin_birth_date = 'Administrador deve ser maior de 18 anos';
      }
    }

    // ✅ NOVO - Validar renda mensal (PF)
    if (!formData.monthly_income.trim()) {
      newErrors.monthly_income = 'Renda mensal é obrigatória';
    } else if (isNaN(parseFloat(formData.monthly_income))) {
      newErrors.monthly_income = 'Renda deve ser um valor numérico';
    }

    // ✅ NOVO - Validar ocupação profissional (PF)
    if (!formData.professional_occupation.trim()) {
      newErrors.professional_occupation = 'Ocupação profissional é obrigatória';
    }

    // ===== DADOS DO ENDEREÇO =====
    
    // Validar CEP
    if (!formData.address_cep.trim()) {
      newErrors.address_cep = 'CEP é obrigatório';
    }

    // Validar rua
    if (!formData.address_street.trim()) {
      newErrors.address_street = 'Endereço é obrigatório';
    }

    // Validar número
    if (!formData.address_number.trim()) {
      newErrors.address_number = 'Número é obrigatório';
    }

    // Validar bairro
    if (!formData.address_neighborhood.trim()) {
      newErrors.address_neighborhood = 'Bairro é obrigatório';
    }

    // Validar cidade
    if (!formData.address_city.trim()) {
      newErrors.address_city = 'Cidade é obrigatória';
    }

    // Validar estado
    if (!formData.address_state.trim()) {
      newErrors.address_state = 'Estado é obrigatório';
    }

    // ✅ NOVO - Validar ponto de referência (OBRIGATÓRIO)
    if (!formData.address_reference.trim()) {
      newErrors.address_reference = 'Ponto de referência é obrigatório';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Carregar documentos do responsável
  const loadDocuments = async () => {
    if (!id) return;
    try {
      const response = await ResponsiblesService.getDocuments(id);
      if (response.success) {
        setDocuments(response.data);
      }
    } catch (error) {
      console.error('Erro ao carregar documentos:', error);
    }
  };

  // Upload de documento
  const handleDocumentUpload = async () => {
    if (!selectedFile) {
      toast.error('Selecione um arquivo');
      return;
    }

    // Se estiver criando novo responsável, adiciona à lista pendente
    if (!isEditing) {
      const newPendingDoc = {
        id: `pending-${Date.now()}`,
        doc_type: selectedDocType,
        file: selectedFile,
        fileName: selectedFile.name,
        uploadedAt: new Date().toISOString()
      };
      setPendingDocuments([...pendingDocuments, newPendingDoc]);
      setSelectedFile(null);
      toast.success('Documento adicionado! Será enviado após salvar o responsável.');
      return;
    }

    // Se estiver editando, faz upload direto
    try {
      setUploadingDocument(true);
      await ResponsiblesService.uploadDocument(id, selectedDocType, selectedFile);
      toast.success('Documento enviado com sucesso!');
      setSelectedFile(null);
      await loadDocuments();
    } catch (error) {
      console.error('Erro ao enviar documento:', error);
      toast.error(error.response?.data?.message || 'Erro ao enviar documento');
    } finally {
      setUploadingDocument(false);
    }
  };

  // Remover documento pendente (antes de salvar)
  const handleRemovePendingDocument = (docId) => {
    setPendingDocuments(pendingDocuments.filter(doc => doc.id !== docId));
    toast.success('Documento removido da lista');
  };

  // Confirmar remoção de documento (já salvo)
  const handleConfirmDelete = (doc) => {
    setDocumentToDelete(doc);
    setShowDeleteModal(true);
  };

  // Remover documento do servidor
  const handleDeleteDocument = async () => {
    if (!documentToDelete) return;

    try {
      setDeletingDocument(true);
      await ResponsiblesService.deleteDocument(id, documentToDelete.id);
      toast.success('Documento removido com sucesso!');
      await loadDocuments();
      setShowDeleteModal(false);
      setDocumentToDelete(null);
    } catch (error) {
      console.error('Erro ao remover documento:', error);
      toast.error(error.response?.data?.message || 'Erro ao remover documento');
    } finally {
      setDeletingDocument(false);
    }
  };

  // Upload de documentos pendentes após criar responsável
  const uploadPendingDocuments = async (responsibleId) => {
    if (pendingDocuments.length === 0) return;

    console.log('📤 Enviando documentos pendentes:', pendingDocuments.length);
    
    for (const pendingDoc of pendingDocuments) {
      try {
        await ResponsiblesService.uploadDocument(
          responsibleId, 
          pendingDoc.doc_type, 
          pendingDoc.file
        );
        console.log('✅ Documento enviado:', pendingDoc.doc_type);
      } catch (error) {
        console.error('❌ Erro ao enviar documento pendente:', error);
        toast.warning(`Erro ao enviar documento ${pendingDoc.doc_type}`);
      }
    }
    
    setPendingDocuments([]);
    toast.success('Todos os documentos foram enviados!');
  };

  // Gerenciar seleção de arquivo
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar tipo de arquivo
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Formato inválido. Use PDF, JPG ou PNG');
      return;
    }

    // Validar tamanho (5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Arquivo muito grande. Tamanho máximo: 5MB');
      return;
    }

    setSelectedFile(file);
  };

  // Submeter formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      toast.error('Por favor, corrija os erros no formulário');
      return;
    }

    try {
      setLoading(true);
      
      // Preparar dados para envio
      const dataToSend = {
        ...formData,
        // Documentos (apenas números)
        responsible_cpf: formData.responsible_cpf.replace(/[^\d]/g, ''),
        admin_cpf: formData.admin_cpf.replace(/[^\d]/g, ''),
        responsible_phone: formData.responsible_phone.replace(/[^\d]/g, ''),
        address_cep: formData.address_cep.replace(/[^\d]/g, ''),
        
        // ✅ NOVO - Converter valores monetários para centavos
        monthly_income: formData.monthly_income ? Math.round(parseFloat(formData.monthly_income.replace(',', '.')) * 100) : null,
        annual_revenue: formData.annual_revenue ? Math.round(parseFloat(formData.annual_revenue.replace(',', '.')) * 100) : null,
      };

      if (isEditing) {
        await ResponsiblesService.updateResponsible(id, dataToSend);
        toast.success('Responsável atualizado com sucesso!');
        navigate('/responsibles');
      } else {
        // Criar responsável e fazer upload dos documentos pendentes
        const response = await ResponsiblesService.createResponsible(dataToSend);
        toast.success('Responsável cadastrado com sucesso!');
        
        // Se houver documentos pendentes, fazer upload
        if (pendingDocuments.length > 0 && response?.data?.id) {
          await uploadPendingDocuments(response.data.id);
        }
        
        navigate('/responsibles');
      }
    } catch (error) {
      console.error('Erro ao salvar responsável:', error);
      
      // Mensagem de erro detalhada do backend
      const errorMessage = error.response?.data?.message || 'Erro ao salvar responsável';
      toast.error(errorMessage);
      
      // Se for erro de CPF duplicado, focar no campo
      if (errorMessage.includes('CPF') && errorMessage.includes('cadastrado')) {
        const cpfField = document.querySelector('input[name="responsible_cpf"]');
        if (cpfField) cpfField.focus();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* CSS customizado */}
      <style>{`
        .form-section {
          background: #ffffff;
          border: 1px solid #e3e6f0;
          border-radius: 0.75rem;
          box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
          margin-bottom: 2rem;
          overflow: hidden;
        }
        
        .form-section-header {
          background: #f8f9fa;
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e3e6f0;
        }
        
        .form-section-body {
          padding: 2rem;
        }
        
        .form-control, .form-select {
          border: 1px solid #d1d3e2;
          border-radius: 0.5rem;
          padding: 0.75rem 1rem;
          font-size: 0.95rem;
          transition: all 0.3s ease;
        }
        
        .form-control:focus, .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
        }
        
        .form-label {
          font-weight: 600;
          color: #2e2e2e;
          margin-bottom: 0.5rem;
        }
        

        
        .section-icon {
          width: 40px;
          height: 40px;
          background: #e9ecef;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;
        }
      `}</style>

      <MasterLayout>
        <Breadcrumb 
          title={isEditing ? "Editar Responsável" : "Adicionar Responsável"}
          items={[
            { label: 'Dashboard', path: '/Dashboard' },
            { label: 'Responsáveis', path: '/responsibles' }
          ]}
        />
        
        <div className="container-fluid px-4">
          {/* Header */}
          <div className="mb-4">
            <span className="d-inline-flex align-items-center fw-bold text-dark" style={{ fontSize: '32px', lineHeight: 1 }}>
              <Icon icon="mdi:account-plus" className="me-3 text-primary" style={{ fontSize: '0.8em' }} />
              {isEditing ? "Editar Responsável" : "Cadastrar Novo Responsável"}
            </span>
            <p className="text-muted mb-0 mt-2" style={{ fontSize: '16px', maxWidth: '600px' }}>
              {isEditing ? "Atualize as informações do responsável legal." : "Cadastre um responsável legal para sua conta. Após aprovação, você poderá cadastrar produtos e vincular contas bancárias."}
            </p>
          </div>

          <div className="row">
            <div className="col-12">
              {/* Alert para responsáveis rejeitados */}
              {isEditing && formData.status === 'rejected' && formData.rejection_reason && (
                <Alert variant="danger" className="mb-4">
                  <div className="d-flex align-items-start">
                    <Icon icon="mdi:alert-circle" className="me-2 mt-1" size="20" />
                    <div>
                      <strong>Solicitação Rejeitada</strong>
                      <p className="mb-0 mt-2">
                        <strong>Motivo:</strong> {formData.rejection_reason}
                      </p>
                      <p className="mb-0 mt-2 small text-muted">
                        Corrija as informações abaixo e reenvie para análise.
                      </p>
                    </div>
                  </div>
                </Alert>
              )}
              
              <Alert variant="info" className="mb-4">
                <Icon icon="mdi:information" className="me-2" />
                <strong>Importante:</strong> Os dados do responsável passarão por análise. 
                Após aprovação, você poderá cadastrar produtos na plataforma.
              </Alert>

              <Form onSubmit={handleSubmit}>
                {/* DADOS DO RESPONSÁVEL */}
                <div className="form-section">
                  <div className="form-section-header">
                    <div className="d-flex align-items-center">
                      <div className="section-icon">
                        <Icon icon="mdi:domain" className="text-primary" size="20" />
                      </div>
                      <div>
                        <h5 className="text-dark mb-1 fw-bold">Dados do Responsável</h5>
                        <p className="text-muted mb-0 small">Informações da empresa ou pessoa jurídica</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-section-body">
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>CNPJ *</Form.Label>
                          <Form.Control
                            type="text"
                            name="responsible_cpf"
                            value={formData.responsible_cpf}
                            onChange={handleChange}
                            isInvalid={!!errors.responsible_cpf}
                            placeholder="00.000.000/0001-00"
                            maxLength="18"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.responsible_cpf}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Inscrição Estadual</Form.Label>
                          <div className="d-flex">
                            <Form.Control
                              type="text"
                              name="state_registration"
                              value={formData.state_registration}
                              onChange={handleChange}
                              placeholder="123456789"
                            />
                            <Button variant="outline-secondary" className="ms-2" size="sm">
                              Isento
                            </Button>
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Razão Social *</Form.Label>
                          <Form.Control
                            type="text"
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleChange}
                            placeholder="Digite a razão social"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Nome Fantasia</Form.Label>
                          <Form.Control
                            type="text"
                            name="trading_name"
                            value={formData.trading_name}
                            onChange={handleChange}
                            placeholder="Digite o nome fantasia"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Telefone</Form.Label>
                          <Form.Control
                            type="text"
                            name="responsible_phone"
                            value={formData.responsible_phone}
                            onChange={handleChange}
                            placeholder="(11) 99999-9999"
                            maxLength="15"
                          />
                        </Form.Group>
                      </Col>

                      {/* ✅ NOVOS CAMPOS DA EMPRESA */}
                      
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Data de Fundação *</Form.Label>
                          <Form.Control
                            type="date"
                            name="founding_date"
                            value={formData.founding_date}
                            onChange={handleChange}
                            isInvalid={!!errors.founding_date}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.founding_date}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Data de abertura da empresa
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Site da Empresa *</Form.Label>
                          <Form.Control
                            type="url"
                            name="site_url"
                            value={formData.site_url}
                            onChange={handleChange}
                            isInvalid={!!errors.site_url}
                            placeholder="https://www.empresa.com.br"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.site_url}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            URL completa do site da empresa
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Faturamento Anual (Opcional)</Form.Label>
                          <Form.Control
                            type="text"
                            name="annual_revenue"
                            value={formData.annual_revenue}
                            onChange={handleChange}
                            isInvalid={!!errors.annual_revenue}
                            placeholder="Ex: 120000.00"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.annual_revenue}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Faturamento anual em R$ (apenas números e ponto)
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>

                {/* DADOS DO SÓCIO ADMINISTRADOR */}
                <div className="form-section">
                  <div className="form-section-header">
                    <div className="d-flex align-items-center">
                      <div className="section-icon">
                        <Icon icon="mdi:account-supervisor" className="text-primary" size="20" />
                      </div>
                      <div>
                        <h5 className="text-dark mb-1 fw-bold">Dados do Sócio Administrador</h5>
                        <p className="text-muted mb-0 small">Informações da pessoa física responsável</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-section-body">
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>CPF *</Form.Label>
                          <Form.Control
                            type="text"
                            name="admin_cpf"
                            value={formData.admin_cpf}
                            onChange={handleChange}
                            isInvalid={!!errors.admin_cpf}
                            placeholder="000.000.000-00"
                            maxLength="14"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.admin_cpf}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Nome *</Form.Label>
                          <Form.Control
                            type="text"
                            name="admin_name"
                            value={formData.admin_name}
                            onChange={handleChange}
                            isInvalid={!!errors.admin_name}
                            placeholder="Nome completo do administrador"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.admin_name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Nome da mãe *</Form.Label>
                          <Form.Control
                            type="text"
                            name="admin_mother_name"
                            value={formData.admin_mother_name}
                            onChange={handleChange}
                            isInvalid={!!errors.admin_mother_name}
                            placeholder="Nome completo da mãe"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.admin_mother_name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Data de Nascimento *</Form.Label>
                          <Form.Control
                            type="date"
                            name="admin_birth_date"
                            value={formData.admin_birth_date}
                            onChange={handleChange}
                            isInvalid={!!errors.admin_birth_date}
                            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.admin_birth_date}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Maior de 18 anos
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      {/* ✅ NOVOS CAMPOS DA EMPRESA */}
                      
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Renda Mensal *</Form.Label>
                          <Form.Control
                            type="text"
                            name="monthly_income"
                            value={formData.monthly_income}
                            onChange={handleChange}
                            isInvalid={!!errors.monthly_income}
                            placeholder="Ex: 5000.00"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.monthly_income}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Renda mensal em R$ (apenas números e ponto)
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Ocupação Profissional *</Form.Label>
                          <Form.Control
                            type="text"
                            name="professional_occupation"
                            value={formData.professional_occupation}
                            onChange={handleChange}
                            isInvalid={!!errors.professional_occupation}
                            placeholder="Ex: Desenvolvedor, Empresário, Comerciante"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.professional_occupation}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Profissão ou ocupação principal
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>

                {/* DADOS DO ENDEREÇO */}
                <div className="form-section">
                  <div className="form-section-header">
                    <div className="d-flex align-items-center">
                      <div className="section-icon">
                        <Icon icon="mdi:map-marker" className="text-primary" size="20" />
                      </div>
                      <div>
                        <h5 className="text-dark mb-1 fw-bold">Dados do Endereço</h5>
                        <p className="text-muted mb-0 small">Localização da empresa</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-section-body">
                    <Row className="g-3">
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>
                            CEP * 
                            <Icon 
                              icon="mdi:magnify" 
                              className="ms-1" 
                              style={{ fontSize: '14px', color: '#6c757d' }}
                              title="Digite o CEP para preenchimento automático"
                            />
                          </Form.Label>
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              name="address_cep"
                              value={formData.address_cep}
                              onChange={handleChange}
                              isInvalid={!!errors.address_cep}
                              placeholder="00000-000"
                              maxLength="9"
                              disabled={cepLoading}
                            />
                            {cepLoading && (
                              <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                  <span className="visually-hidden">Buscando...</span>
                                </div>
                              </div>
                            )}
                          </div>
                          <Form.Control.Feedback type="invalid">
                            {errors.address_cep}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Digite o CEP para preenchimento automático do endereço
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col md={8}>
                        <Form.Group>
                          <Form.Label>Endereço *</Form.Label>
                          <Form.Control
                            type="text"
                            name="address_street"
                            value={formData.address_street}
                            onChange={handleChange}
                            isInvalid={!!errors.address_street}
                            placeholder="Rua, Av., Trav."
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address_street}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Número *</Form.Label>
                          <Form.Control
                            type="text"
                            name="address_number"
                            value={formData.address_number}
                            onChange={handleChange}
                            isInvalid={!!errors.address_number}
                            placeholder="123"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address_number}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={8}>
                        <Form.Group>
                          <Form.Label>Complemento</Form.Label>
                          <Form.Control
                            type="text"
                            name="address_complement"
                            value={formData.address_complement}
                            onChange={handleChange}
                            placeholder="Casa-A, Apt. 123"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Bairro *</Form.Label>
                          <Form.Control
                            type="text"
                            name="address_neighborhood"
                            value={formData.address_neighborhood}
                            onChange={handleChange}
                            isInvalid={!!errors.address_neighborhood}
                            placeholder="Digite o bairro"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address_neighborhood}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Cidade *</Form.Label>
                          <Form.Control
                            type="text"
                            name="address_city"
                            value={formData.address_city}
                            onChange={handleChange}
                            isInvalid={!!errors.address_city}
                            placeholder="Digite a cidade"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address_city}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Estado *</Form.Label>
                          <Form.Select
                            name="address_state"
                            value={formData.address_state}
                            onChange={handleChange}
                            isInvalid={!!errors.address_state}
                          >
                            <option value="">Selecione</option>
                            <option value="AC">Acre</option>
                            <option value="AL">Alagoas</option>
                            <option value="AP">Amapá</option>
                            <option value="AM">Amazonas</option>
                            <option value="BA">Bahia</option>
                            <option value="CE">Ceará</option>
                            <option value="DF">Distrito Federal</option>
                            <option value="ES">Espírito Santo</option>
                            <option value="GO">Goiás</option>
                            <option value="MA">Maranhão</option>
                            <option value="MT">Mato Grosso</option>
                            <option value="MS">Mato Grosso do Sul</option>
                            <option value="MG">Minas Gerais</option>
                            <option value="PA">Pará</option>
                            <option value="PB">Paraíba</option>
                            <option value="PR">Paraná</option>
                            <option value="PE">Pernambuco</option>
                            <option value="PI">Piauí</option>
                            <option value="RJ">Rio de Janeiro</option>
                            <option value="RN">Rio Grande do Norte</option>
                            <option value="RS">Rio Grande do Sul</option>
                            <option value="RO">Rondônia</option>
                            <option value="RR">Roraima</option>
                            <option value="SC">Santa Catarina</option>
                            <option value="SP">São Paulo</option>
                            <option value="SE">Sergipe</option>
                            <option value="TO">Tocantins</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.address_state}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* ✅ NOVO CAMPO DO ENDEREÇO */}
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Ponto de Referência *</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="address_reference"
                            value={formData.address_reference}
                            onChange={handleChange}
                            isInvalid={!!errors.address_reference}
                            placeholder="Ex: Próximo ao mercado, em frente à praça, ao lado do banco..."
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address_reference}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Referência para localização do endereço
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>

                {/* DOCUMENTOS DO SÓCIO ADMINISTRADOR */}
                {(!isEditing || formData.status === 'pending_validation' || formData.status === 'rejected') && (
                  <div className="form-section">
                    <div className="form-section-header">
                      <div className="d-flex align-items-center">
                        <div className="section-icon">
                          <Icon icon="mdi:file-document-check" className="text-primary" size="20" />
                        </div>
                        <div>
                          <h5 className="text-dark mb-1 fw-bold">Documentos do Sócio</h5>
                          <p className="text-muted mb-0 small">
                            {!isEditing 
                              ? 'Adicione os documentos agora, eles serão enviados após salvar o responsável' 
                              : 'Envie o documento do sócio administrador'}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-section-body">
                      {/* Upload de novo documento */}
                      <Row className="g-3 mb-4">
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label>Tipo de Documento</Form.Label>
                            <Form.Select
                              value={selectedDocType}
                              onChange={(e) => setSelectedDocType(e.target.value)}
                              disabled={uploadingDocument}
                            >
                              <option value="CNH">CNH</option>
                              <option value="RG">RG</option>
                              <option value="CPF">CPF</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group>
                            <Form.Label>Arquivo</Form.Label>
                            <Form.Control
                              type="file"
                              accept=".pdf,.jpg,.jpeg,.png"
                              onChange={handleFileSelect}
                              disabled={uploadingDocument}
                            />
                            <Form.Text className="text-muted">
                              PDF, JPG ou PNG (máx. 5MB)
                            </Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={3} className="d-flex align-items-end">
                          <Button
                            variant="primary"
                            onClick={handleDocumentUpload}
                            disabled={!selectedFile || uploadingDocument}
                            className="w-100"
                          >
                            {uploadingDocument ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Enviando...
                              </>
                            ) : (
                              <>
                                <Icon icon="mdi:upload" className="me-2" />
                                {isEditing ? 'Enviar' : 'Adicionar'}
                              </>
                            )}
                          </Button>
                        </Col>
                      </Row>

                      {/* Documentos pendentes (apenas no cadastro novo) */}
                      {!isEditing && pendingDocuments.length > 0 && (
                        <div className="mb-4">
                          <h6 className="mb-3">Documentos Adicionados</h6>
                          <div className="d-flex flex-column gap-2">
                            {pendingDocuments.map((doc) => (
                              <div
                                key={doc.id}
                                className="d-flex align-items-center justify-content-between p-3 border rounded"
                                style={{ backgroundColor: '#fff3cd' }}
                              >
                                <div className="d-flex align-items-center">
                                  <Icon
                                    icon="mdi:file-clock"
                                    className="text-warning me-3"
                                    size="24"
                                  />
                                  <div>
                                    <div className="fw-medium">{doc.doc_type}</div>
                                    <div className="text-muted small">{doc.fileName}</div>
                                  </div>
                                </div>
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => handleRemovePendingDocument(doc.id)}
                                >
                                  <Icon icon="mdi:delete" className="me-1" />
                                  Remover
                                </Button>
                              </div>
                            ))}
                          </div>
                          <Alert variant="warning" className="mt-3 mb-0">
                            <Icon icon="mdi:information" className="me-2" />
                            Estes documentos serão enviados automaticamente após salvar o responsável.
                          </Alert>
                        </div>
                      )}

                      {/* Lista de documentos enviados (apenas na edição) */}
                      {isEditing && documents.length > 0 && (
                        <div>
                          <h6 className="mb-3">Documentos Enviados</h6>
                          <div className="d-flex flex-column gap-2">
                            {documents.map((doc) => (
                              <div
                                key={doc.id}
                                className="d-flex align-items-center justify-content-between p-3 border rounded"
                                style={{ backgroundColor: '#f8f9fa' }}
                              >
                                <div className="d-flex align-items-center">
                                  <Icon
                                    icon="mdi:file-check"
                                    className="text-success me-3"
                                    size="24"
                                  />
                                  <div>
                                    <div className="fw-medium">{doc.doc_type}</div>
                                    <div className="text-muted small">
                                      Enviado em {new Date(doc.uploaded_at).toLocaleDateString('pt-BR')}
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex gap-2">
                                  <a
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-primary btn-sm"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    <Icon icon="mdi:eye" className="me-1" />
                                    Visualizar
                                  </a>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleConfirmDelete(doc)}
                                  >
                                    <Icon icon="mdi:delete" className="me-1" />
                                    Remover
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {isEditing && documents.length === 0 && (
                        <Alert variant="info" className="mb-0">
                          <Icon icon="mdi:information" className="me-2" />
                          Nenhum documento enviado ainda. Envie o documento do sócio administrador acima.
                        </Alert>
                      )}
                    </div>
                  </div>
                )}

                {/* CONFIGURAÇÕES FINAIS */}
                <div className="form-section">
                  <div className="form-section-header">
                    <div className="d-flex align-items-center">
                      <div className="section-icon">
                        <Icon icon="mdi:cog" className="text-primary" size="20" />
                      </div>
                      <div>
                        <h5 className="text-dark mb-1 fw-bold">Configurações</h5>
                        <p className="text-muted mb-0 small">Definições adicionais</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-section-body">
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        name="is_main_responsible"
                        checked={formData.is_main_responsible}
                        onChange={handleChange}
                        label="Definir como responsável principal da conta"
                        className="mb-2"
                        style={{ fontSize: '1rem' }}
                      />
                      <Form.Text className="text-muted">
                        O responsável principal aparecerá primeiro na lista e terá destaque especial nas operações financeiras.
                      </Form.Text>
                    </Form.Group>
                  </div>
                </div>

                {/* Botões */}
                <div className="d-flex gap-3 justify-content-end mt-4">
                  <Button
                    variant="outline-secondary"
                    onClick={() => navigate('/responsibles')}
                    disabled={loading}
                  >
                    <Icon icon="mdi:arrow-left" className="me-2" />
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {isEditing ? 'Atualizando...' : 'Cadastrando...'}
                      </>
                    ) : (
                      <>
                        <Icon icon="mdi:content-save" className="me-2" />
                        {isEditing ? 'Atualizar Responsável' : 'Cadastrar Responsável'}
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>

        {/* Modal de confirmação de exclusão */}
        {showDeleteModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <Icon icon="mdi:alert-circle" className="text-danger me-2" />
                    Confirmar Remoção
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                    disabled={deletingDocument}
                  />
                </div>
                <div className="modal-body">
                  <p className="mb-0">
                    Tem certeza que deseja remover o documento <strong>{documentToDelete?.doc_type}</strong>?
                  </p>
                  <p className="text-muted small mt-2 mb-0">
                    Esta ação não pode ser desfeita.
                  </p>
                </div>
                <div className="modal-footer">
                  <Button
                    variant="secondary"
                    onClick={() => setShowDeleteModal(false)}
                    disabled={deletingDocument}
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant="danger"
                    onClick={handleDeleteDocument}
                    disabled={deletingDocument}
                  >
                    {deletingDocument ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Removendo...
                      </>
                    ) : (
                      <>
                        <Icon icon="mdi:delete" className="me-2" />
                        Remover
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </MasterLayout>
    </>
  );
};

export default ResponsibleFormPage;
